import React from 'react';
import { styled } from 'styled-components';

const CardContainer = styled.div`
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.2rem;
  margin: 1.2rem;
`;

export const Card = ({ children }) => {
  return <CardContainer>{children}</CardContainer>;
};
